interface Config {
    name: string;
    apiServer: string;
    imageServer: string;
    liffId: string;
    ga: string;
}

export const getConfig = (): Config => {
    return (window as any).ENV;
}

export const getImageLink = (path: string): string => {
    return `${getConfig().imageServer}${path}`;
}
